import React, { PropsWithChildren } from "react";
import styled from "styled-components";

type Props = {
  className?: string;
};

const Container: React.FC<PropsWithChildren & Props> = ({ children, ...props }) => {
  return (
    <ContainerStyled {...props} className={`${props?.className ?? ""} container`}>
      {children}
    </ContainerStyled>
  );
};

const ContainerStyled = styled.div<Props>``;

export default Container;
